import React from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import FormLogin from "./components/FormLogin";
import homeImg from '../../../assets/images/home-svg.jpg';
import { BORROWER_ONBOARDING_URL } from "@common/config/environments";

const Login = () => {
  const [searchParams] = useSearchParams();
  const changePassword = searchParams.get('changePassword');
  const redirectUrl = searchParams.get('redirect');

  const title = changePassword === 'true'
    ? "Your password has been <br />changed"
    : "Welcome back to <br />Constitution Lending!";

  const subtitle = changePassword === 'true'
    ? "Login below"
    : "Please enter your details"

  return (
    <Layout>
      <div className="Login">
        <div className="Login-colum"></div>
        <div className="Login-form">
          <h1 
            className={`h1 ${changePassword === 'true' ? 'h1-change-password' : ''}`}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          {subtitle && <p className="subtitle">{subtitle}</p>}
          <FormLogin redirectUrl={redirectUrl} />
          <a
            className="body-regular link-absolute"
            href={`${BORROWER_ONBOARDING_URL}/`}
            rel="noopener noreferrer"
          >
            Don&apos;t have an account?{" "}
            <span className="body-regular-bold">Price your first loan</span>
          </a>
        </div>
        <div className="right">
          <div className="content">
            <div>
              <img className="star" src="https://storage.googleapis.com/constlending-borrowers/static/star-vector.svg" />
            </div>
            <p className="phrase">
              &quot;Dealing with multiple lenders is exhausting and wondering if I&apos;d get financing made me apprehensive about chasing deals. Thanks to you, I can just focus on buying properties!&quot;
            </p>
            <div className="author">
              <b>Chandra M</b>
              <br></br>
              Real estate investor
            </div>
          </div>
          <div>
            <img className="home" src={homeImg} />
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default Login;
